import React from "react";
import useUniqueId from "../../../hooks/use-unique-id";

const AutopayWalletIcon = ({ title }) => {
  const gradientId = useUniqueId("autopay-wallet-gradient");
  return (
    <svg
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : "true"}
      aria-label={title || undefined}
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {title && <title>{title}</title>}
      <rect y="16" width="64" height="48" rx="6" fill="#317D4F" />
      <path
        d="M40.3857 48C40.6834 48.0001 40.916 48.2595 40.8652 48.5527C40.1294 52.783 36.4407 55.9998 32 56C29.2599 55.9999 26.8065 54.7748 25.1562 52.8428L23.8535 54.1465C23.5385 54.4614 23.0001 54.2384 23 53.793V49.5C23 49.2239 23.2239 49 23.5 49H27.793C28.2384 49.0001 28.4614 49.5385 28.1465 49.8535L26.5762 51.4229C27.8597 52.9951 29.8122 53.9999 32 54C35.3765 53.9998 38.1943 51.6089 38.8535 48.4277C38.904 48.1843 39.1127 48.0002 39.3613 48H40.3857ZM32 38C34.7397 38.0001 37.1917 39.2258 38.8418 41.1572L40.1465 39.8535C40.4615 39.5386 40.9999 39.7616 41 40.207V44.5C41 44.7761 40.7761 45 40.5 45H36.207C35.7616 44.9999 35.5386 44.4615 35.8535 44.1465L37.4238 42.5752C36.1404 41.0036 34.1873 40.0001 32 40C28.6235 40.0002 25.8057 42.3911 25.1465 45.5723C25.096 45.8157 24.8873 45.9998 24.6387 46H23.6143C23.3166 45.9999 23.084 45.7406 23.1348 45.4473C23.8706 41.217 27.5593 38.0002 32 38Z"
        fill="white"
      />
      <path
        d="M0 22C0 18.6863 2.68629 16 6 16H58C61.3137 16 64 18.6863 64 22V29H0V22Z"
        fill={`url(#${gradientId})`}
        fillOpacity="0.2"
      />
      <path
        d="M10 4C10 1.79086 11.7909 0 14 0H50C52.2091 0 54 1.79086 54 4V29H10V4Z"
        fill="#D0C7FD"
      />
      <rect x="37" width="8" height="29" fill="#3B414D" />
      <path
        d="M16 7.5C16 6.39543 16.8954 5.5 18 5.5C19.1046 5.5 20 6.39543 20 7.5V13.5C20 14.6046 19.1046 15.5 18 15.5C16.8954 15.5 16 14.6046 16 13.5V7.5Z"
        fill="#3B414D"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="0"
          y1="29"
          x2="0"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopOpacity="0.05" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AutopayWalletIcon;
